import { z } from 'zod'

export const schema = z.object({
  price: z
    .object({
      amount: z.number().int(),
      currency: z.enum(['EUR']),
    })
    .nullable(),
  type: z.enum(['exact', 'from']).nullable(),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  id: z.string(),
  dateIn: z.string(),
  dateOut: z.string(),
  numPeople: z.number().int().nullable(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
